import { render, staticRenderFns } from "./FreeDashboard.vue?vue&type=template&id=2ff4796e&"
import script from "./FreeDashboard.vue?vue&type=script&lang=js&"
export * from "./FreeDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FreeDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports